module.exports = __webpack_public_path__ + "static/media/nonprofit2.d3476971.png";